import httpClient from "@lab/api/httpClient";
import {
	HomeCareProvider,
	HomeCareProviderCreate
} from "@lab/types/homecareprovider";

export const homecareprovider = {
	get: async (id: number): Promise<HomeCareProvider | undefined> => {
		const response = await httpClient.get(`/homecareproviders/${id}`);
		return response.data as HomeCareProvider;
	},
	create: async (
		provider: HomeCareProviderCreate
	): Promise<HomeCareProvider | undefined> => {
		const response = await httpClient.post(`/homecareproviders`, provider);
		return response.data as HomeCareProvider;
	},
	update: async (
		provider: HomeCareProvider
	): Promise<HomeCareProvider | undefined> => {
		const { id } = provider;
		const response = await httpClient.put(
			`/homecareproviders/${id}`,
			provider
		);
		return response.data as HomeCareProvider;
	}
};

export const mediaImages = {
	update: async (id: number, images: any[]) => {
		const response = await httpClient.post(
			`/homecareproviders/${id}/mediaimages`,
			images
		);
		return response.data;
	}
};
export const mediaFiles = {
	update: async (id: number, files: any[]) => {
		const response = await httpClient.post(
			`/homecareproviders/${id}/mediapdfs`,
			files
		);
		return response.data;
	}
};
